import React from 'react';
import { MapPin, Star } from 'lucide-react';
export function VenueHighlight() {
  return <section id="venue" className="py-24 bg-[#2F1B10] text-white relative" data-id="element-252" data-mp="8tlnva7n0gqx">
      <div className="container mx-auto px-4 md:px-6" data-id="element-253" data-mp="8vycg67whpcy">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-254" data-mp="dsf43aeb6lus">
          <div className="order-2 lg:order-1" data-id="element-255" data-mp="isky2x81wkg1">
            <div className="relative" data-id="element-256" data-mp="iq89403vl9th">
              <div className="absolute -top-4 -left-4 w-24 h-24 border-t-4 border-l-4 border-[#D2691E] opacity-50" data-id="element-257" data-mp="mug0y65mr5vx"></div>
              <img src="https://images.unsplash.com/photo-1558030006-450675393462?w=1000&q=80" alt="Texas BBQ Brisket" className="rounded-lg shadow-2xl w-full h-auto object-cover grayscale hover:grayscale-0 transition-all duration-700" data-id="element-258" data-mp="rry054tui6qq" />
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-4 border-r-4 border-[#D2691E] opacity-50" data-id="element-259" data-mp="16ix6sab4el7o"></div>
            </div>
            <div className="mt-8 grid grid-cols-2 gap-4" data-id="element-260" data-mp="1ah4l6yi43afp">
              <img src="https://images.unsplash.com/photo-1555939594-58d7cb561ad1?w=800&q=80" alt="BBQ Restaurant" className="rounded-lg shadow-lg h-48 w-full object-cover grayscale hover:grayscale-0 transition-all duration-700" data-id="element-261" data-mp="3roxbe7ukx0an" />
              <div className="bg-[#8B4513] rounded-lg p-6 flex flex-col justify-center items-center text-center border border-[#D2691E]" data-id="element-262" data-mp="3cry6irr43ljv">
                <Star className="text-[#F4A460] mb-2" size={32} fill="#F4A460" data-id="element-263" data-mp="ebc1eujyfuna" />
                <span className="text-3xl font-bold font-serif text-white" data-id="element-264" data-mp="4io7c7kd04s9">
                  #1
                </span>
                <span className="text-[#F4A460] font-medium" data-id="element-265" data-mp="3vozbicko1lnt">
                  BBQ in America
                </span>
              </div>
            </div>
          </div>

          <div className="order-1 lg:order-2" data-id="element-266" data-mp="s8imwww2c7g7">
            <div className="inline-block bg-[#D2691E] text-white px-3 py-1 rounded-full text-sm font-bold mb-6 tracking-wide uppercase" data-id="element-267" data-mp="s7pi41gnzs0p">
              Venue Highlight
            </div>
            <h2 className="text-4xl md:text-5xl font-bold mb-6 font-serif text-[#FFF8DC]" style={{
            fontFamily: 'Rockwell, "Courier New", serif'
          }} data-id="element-268" data-mp="2rfftlehc9vk7">
              Franklin Barbecue <br data-id="element-269" data-mp="23qeg3ctnfu82" />
              <span className="text-[#D2691E]" data-id="element-270" data-mp="23pv6qki2ee5n">Private Dinner</span>
            </h2>

            <p className="text-xl text-gray-300 mb-8 leading-relaxed" data-id="element-271" data-mp="27rq81ozzwrjf">
              We've secured a private takeover of the legendary Franklin
              Barbecue for our evening reception. Experience the brisket that
              changed the BBQ world forever—without the famous 4-hour line.
            </p>

            <ul className="space-y-6" data-id="element-272" data-mp="3o5q7kyuxif65">
              {['Private restaurant takeover - no line required', 'Full menu of brisket, ribs, and sides', 'Local craft beers and drinks included', 'Potential fireside chat with Aaron & Stacy Franklin'].map((item, index) => <li key={index} className="flex items-start" data-id="element-273" data-mp="1ckpl6ou7q9ri" data-mpi={index}>
                  <span className="bg-[#D2691E] rounded-full p-1 mr-4 mt-1" data-id="element-274" data-mp="1r8u701okb1ei">
                    <Star size={12} className="text-white" fill="white" data-id="element-275" data-mp="1mgive1kglr64" />
                  </span>
                  <span className="text-[#F4A460] text-lg" data-id="element-276" data-mp="20879ubi6krq9">{item}</span>
                </li>)}
            </ul>

            <div className="mt-10 flex items-center gap-2 text-gray-400" data-id="element-277" data-mp="1v8che3irbu33">
              <MapPin size={20} className="text-[#D2691E]" data-id="element-278" data-mp="2a76hbqr7mhbo" />
              <span data-id="element-279" data-mp="2a4k9rr4bk1tg">900 E 11th St, Austin, TX 78702</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}